import { RegionShared } from "@1games-ru/region-shared";
import { ShowSignatureModalRequest } from "@1games-ru/region-shared/dist/cef/requests/documents";
import { useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";

export default function useShowSignatureModal() {
  const [isShowSignatureModal, setIsShowSignatureModal] = useState(false);
  const [sigToken, setSigToken] = useState("");

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Documents.ShowSignatureModal,
      (data: ShowSignatureModalRequest) => {
        setIsShowSignatureModal(true);
        setSigToken(data.token);
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Documents.ShowSignatureModal);
    };
  }, []);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Documents.HideSignatureModal, () => {
      setIsShowSignatureModal(false);
      setSigToken("");
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Documents.HideSignatureModal);
    };
  }, []);

  return { isShowSignatureModal, sigToken, setIsShowSignatureModal };
}
